module.exports = __webpack_public_path__ + "static/media/ewans-trust-logo-white.2fecf5e6.svg";